import React, { useEffect, useState } from 'react';

// material-ui
import { Box, Button, Card, Grid, FormControlLabel, Checkbox } from '@mui/material';

// project imports
import Select from 'react-select';
import { discountType, orderTypeCategoryOptions, timeOptions } from 'constant/constant';
import { TCInput, TCSelect, TCSelectStyle } from 'components/TopCourtComponents/Input/TopCourtInput';
import { createCoupons, getCoupon, updateCoupon, getAutoPopupService } from 'services/couponServices';
import { TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';
import { getParamsFromURL } from 'helper/Params';
import moment from 'moment';
import AsyncSelect from 'react-select/async';

import { getPlayers } from 'services/playerServices';
import { useNavigate } from 'react-router';
import { toastMessage } from 'components/Toast/Toast';
import { getPartner } from 'services/partnerServices';
import { NumericFormat } from 'react-number-format';
import ControlledNumericFormat from 'components/TopCourtComponents/Input/ControlledNumericFormat';
import { getSportCourtTypes } from 'services/sportCourtTypeServices';
import { getCategories } from 'services/categoryServices';
import { getUrlCourtCode } from 'helper/Court';
import { isMerchant } from 'helper/Admin';
import { getPlaces } from 'services/placeServices';

const minimumTypeOptions = [
  { value: "purchase", label: "Total Amount" },
  { value: "session", label: "Total Session" }
]

function AddCoupon({

}) {

  const navigate = useNavigate()

  const [form, setForm] = useState({
    name: "",
    promoCode: "",
    promoCodeType: discountType[0],
    paymentType: null, // VA, Bank Transfer
    amount: null,
    orderType: { label: "All", value: 'all' },
    hours: [],
    hourStart: null,
    hourEnd: null,
    issuer: [],
    minimumPurchase: null,
    minimumSessions: null,
    startDate: null,
    endDate: null,
    limit: null,
    limitUser: null,
    limitUserDaily: null,
    user: null,
    isActive: false,
    autoPopup: false,
    minimumType: null,
    sportCourtTypeId: null,
    addOnCategoryId: null,
    placeIds: [],
    merchantIds: [],
  })

  const [loading, setLoading] = useState(false)

  const [disablePopup, setDisablePopup] = useState(true)
  const [endTimeOptions, setEndTimeOptions] = useState([])

  const [bookingCategory, setBookingCategory] = useState([])
  const [addOnCategory, setAddOnCategory] = useState([])

  const [joiForm, setJoiForm] = useState({
    name: form.name ? null : "*",
    promoCode: form.promoCode ? null : "*",
    amount: form.amount ? null : "*",
    promoCodeType: form.promoCodeType ? null : "*",
    minimumPurchase: null,
    minimumSessions: null,
    startDate: form.startDate ? null : "*",
    endDate: form.endDate ? null : "*",
  })

  const onChange = (e) => {
    // check startDate and endDate
    setForm(prev => ({
      ...prev,
      ...e
    }))
  }

  useEffect(() => {
    setJoiForm({
      name: form.name ? null : "*",
      promoCode: form.promoCode ? null : "*",
      amount: form.amount ? null : "*",
      promoCodeType: form.promoCodeType ? null : "*",
      startDate: form.startDate ? null : "*",
      minimumPurchase: ((form.minimumType && form.minimumType.value == "purchase") && !form.minimumPurchase) ? '*' : null,
      minimumSessions: ((form.minimumType && form.minimumType.value == "session") && !form.minimumSessions) ? '*' : null,
      // endDate: (form.endDate && (form.endDate > form.startDate)) ? null : "*",
      endDate: form.endDate ? null : "*",
      limit: (!form.limit && (form.limitUser || form.limitUserDaily) ) ? "*" : null,
      limitUser: (!form.limitUser && form.limitUserDaily) ? '*' : null,
    }) 
  }, [form])

  useEffect(() => {
    let { isEdit, params } = getParamsFromURL(window);
    getAutoPopupInfo()
    loadSportCourtTypeId()
    loadAddOnCategory()
    if (isEdit) { getCouponInfo(params) }
  }, [])

  const getAutoPopupInfo = async () => {
    try {
      let { data, error } = await getAutoPopupService();
      console.log(error, data)
      setDisablePopup(data)
    } catch (error) {
      console.log(error)
    }
  }

  const getCouponInfo = async (id) => {
    try {
      let { data, error } = await getCoupon(id)
      let discountObject = null
      let minimumObject = null
      discountType.map(value => {
        if (value.value == data.promoCodeType) { discountObject = value }
      })
      let endHour = ""
      if (data.hours && data.hours.length > 0) {
        let endHours = timeOptions.filter(opt => opt.value > data.hours[0])
        endHour = data.hours[data.hours.length - 1].split(':')[0]
        endHour = `${Number(endHour) + 1}:00`
        setEndTimeOptions(endHours)
      }
      setForm(prev => ({
        ...prev,
        ...data,
        hourStart: (data.hours && data.hours.length > 0) ? data.hours[0] : null,
        // hourEnd: (data.hours && data.hours.length > 0) ? data.hours[data.hours.length - 1] : null,
        hourEnd: endHour,
        orderType: data.orderType ? MapOptions({ options: orderTypeCategoryOptions, value: data.orderType }) : { label: "All", value: 'all' },
        startDate: moment(data.startDate).format('YYYY-MM-DD'),
        endDate: moment(data.endDate).format('YYYY-MM-DD'),
        user: data.user ? data.user.map(value => { return { value: value._id, label: value.name } }) : null,
        issuer: data.issuer ? data.issuer.map(value => { return { value: value._id, label: value.name } }) : null,
        promoCodeType: discountObject,
        minimumType: data.minimumPurchase ? minimumTypeOptions[0] : data.minimumSessions ? minimumTypeOptions[1] : null,
        sportCourtTypeId: data.sportCourtTypeId ? data.sportCourtTypeId.map(v => { return { value: v._id, label: `${v.sportTypeId.name} ${v.courtTypeId.name}` } }) : null,
        addOnCategoryId: data.addOnCategoryId ? data.addOnCategoryId.map(v => { return { value: v._id, label: v.name } }) : null,
        placeIds: data.placeIds?.map(value => {
          return {
            label: value.name,
            value: value._id,
            merchantId: value.merchantId
          }
        }),
      }))
    } catch (error) {
      console.log('Hello World')
    }
  }

  const saveCodePromo = async () => {
    setLoading(true)
    let body = form
    // body.promoCodeType = body.promoCodeType ? body.promoCodeType.value : null
    // body.user = body.user ? body.user.value : null
    // body.user = body.user ? body.user.map(value => { return value.value }) : null

    if (body.minimumType && body.minimumType.value == "session") {
      body.minimumPurchase = null
    }

    if (body.minimumType && body.minimumType.value == "purchase") {
      body.minimumSessions = null
    }

    if (body.placeIds) {
      form.merchantIds = body.placeIds.map(v => { return v.merchantId })
      form.placeIds = body.placeIds.map(v => { return v.value })
    }

    let hourList = convertHourstoArray({ startHours: form.hourStart, endHours: form.hourEnd })
    if (hourList && hourList.length > 0) { body.hours = hourList }

    // mappingHours

    if (form._id) {
      let { data, error } = await updateCoupon({
        ...form,
        promoCodeType: body.promoCodeType ? body.promoCodeType.value : null,
        orderType: body.orderType ? body.orderType.value : null,
        issuer: body.issuer ? body.issuer.map(value => { return value.value }) : null,
        user: body.user ? body.user.map(value => { return value.value }) : null,
        sportCourtTypeId: body.sportCourtTypeId ? body.sportCourtTypeId.map(value => { return value.value }) : null,
        addOnCategoryId: body.addOnCategoryId ? body.addOnCategoryId.map(value => { return value.value }) : null
      })
      setLoading(false)
      if (error) {
        toastMessage(error, {
          toastId: "code-promo-error",
          type: "error"
        })
      }
      if (data) { window.location.href = `/${getUrlCourtCode()}/coupons` }
    } else {
      let { data, error } = await createCoupons({
        ...form,
        promoCodeType: body.promoCodeType ? body.promoCodeType.value : null,
        orderType: body.orderType ? body.orderType.value : null,
        issuer: body.issuer ? body.issuer.map(value => { return value.value }) : null,
        user: body.user ? body.user.map(value => { return value.value }) : null,
        sportCourtTypeId: body.sportCourtTypeId ? body.sportCourtTypeId.map(value => { return value.value }) : null,
        addOnCategoryId: body.addOnCategoryId ? body.addOnCategoryId.map(value => { return value.value }) : null
      })
      setLoading(false)
      if (error) {
        toastMessage(error, {
          toastId: "code-promo-error",
          type: "error"
        })
      }
      if (data) { window.location.href = `/${getUrlCourtCode()}/coupons` }
    }
  }

  const loadUserOption = async (input) => {
    if (input.length < 1) {
      return
    }
    try {
      let { data, error } = await getPlayers({
        namePhoneNumber: input.replace("+", "")
      });
      if (error) throw error
      if (data) {
        if (data.length <= 0) return
        return data.map(value => {
          return {
            label: value.name,
            value: value._id
          }
        })
      }
    } catch (error) {
      console.log(error.message || error)
      return ([])
    }
  }

  const loadPlaceOptions = async (input) => {
    try {
      let { data, error } = await getPlaces({
        name: input
      });
      if (error) throw error
      if (data) {
        console.log('here data info', data)
        if (data.length <= 0) return
        return data.map(value => {
          return {
            label: value.name,
            value: value._id,
            merchantId: value.merchantId
          }
        })
      }
    } catch (error) {
      console.log(error.message || error)
      return ([])
    }
  }

  const loadIssuerOption = async (input) => {
    if (input.length < 1) {
      return
    }
    try {
      console.log('here input', input)
      let { data, error } = await getPartner({ name: input })
      if (error) throw error
      if (data) {
        if (data.length <= 0) return
        return data.map(value => {
          return {
            label: value.name,
            value: value._id
          }
        })
      }
    } catch (error) {
      console.log(error.message || error)
      return ([])
    }
  }

  const loadSportCourtTypeId = async () => {
    try {
      let { data, error } = await getSportCourtTypes()
      if (error) { throw error }
      let mappedData = data.map(v => {
        return {
          label: `${v.sportTypeId.name} ${v.courtTypeId.name}`,
          value: `${v._id}`
        }
      })
      setBookingCategory(mappedData)
      console.log('here check sportCourtTypeId', data)
    } catch (error) {
      console.log(error)
    }
  }

  const loadAddOnCategory = async () => {
    try {
      let { data, error } = await getCategories({})
      if (error) { throw error }
      let mappedData = data.map(v => {
        return {
          label: `${v.name}`,
          value: `${v._id}`
        }
      })
      setAddOnCategory(mappedData)
      console.log('here check AddOnCategory', data)
    } catch (error) {
      console.log(error)
    }
  }

  const checkDisabled = () => {
    return joiForm.name || joiForm.promoCode || joiForm.amount || joiForm.startDate || joiForm.minimumPurchase || joiForm.minimumSessions
      || joiForm.endDate || joiForm.promoCodeType || joiForm.limitUser || loading
  }

  return (
    <>
      <Grid container xs={12} md={8} lg={6}>
        <Card sx={{ mb: 3 }}>
          <Box
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Grid container sx={{
              p: 2
            }}>
              {/* <Grid xs={12} md={12} sx={{p: 1}}>
                  <TCTitleLabel>Coupon Information</TCTitleLabel>
                </Grid> */}
              {
                !isMerchant() &&
                <Grid item xs={12} md={12} sx={{ p: 1 }}>
                  <TCLabel style={{ color: 'rgb(133, 133, 133)' }}>Venue</TCLabel>
                  <AsyncSelect
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 }),
                      ...TCSelectStyle,
                    }}
                    placeholder={'Select Places...'}
                    isClearable
                    async
                    defaultOptions
                    loadOptions={loadPlaceOptions}
                    isMulti={true}
                    value={form.placeIds} onChange={(e) => { onChange({ placeIds: e }) }}
                  />
                </Grid>
              }
              <Grid item xs={12} md={12} sx={{ p: 1 }}>
                <TCInput showAlert={joiForm.name} onChange={(e) => onChange({ name: e.currentTarget.value })} value={form.name} label={"Promo Title"} />
              </Grid>
              <Grid item xs={12} md={12} sx={{ p: 1 }}>
                <TCInput showAlert={joiForm.promoCode} onChange={(e) => onChange({ promoCode: e.currentTarget.value.toUpperCase() })} value={form.promoCode} label={"Promo Code"} />
              </Grid>
              <Grid item container xs={12} md={12}>
                <Grid xs={6} md={6} sx={{ p: 1 }}>
                  <TCLabel style={{ color: 'rgb(133, 133, 133)' }}>Discount Type <span style={{ color: '#f44336' }}>{joiForm.promoCodeType}</span></TCLabel>
                  <Select options={discountType} value={form.promoCodeType} onChange={(e) => {
                    onChange({ promoCodeType: e, amount: 0 })
                  }} />
                </Grid>
                <Grid xs={6} md={6} sx={{ p: 1 }}>
                  {/* <TCInput showAlert={joiForm.amount} value={form.amount} onChange={(e) => {
                          let value = e.currentTarget.value.replace(/[^0-9]/g, "")
                          if (!value) {
                              onChange({amount: value})
                              return
                          }
                          if (form.promoCodeType && form.promoCodeType.value == "percentage") {
                            if (Number(value) > 100) { value = 100 }
                          }
                          if (Number(value) <= 0) { value = "" }
                          onChange({amount: value})
                        }} label={"Value"}/> */}
                  <Grid item>
                    <Grid item container spacing={1}>
                      <Grid item>
                        <TCLabel style={{
                          color: 'rgb(133, 133, 133)'
                        }}>Value</TCLabel>
                      </Grid>
                      <Grid item>
                        <TCLabel style={{ color: 'red' }}>{joiForm.amount}</TCLabel>
                      </Grid>
                    </Grid>
                    <ControlledNumericFormat
                      value={form.amount}
                      onValueChange={(values) => {
                        const { formattedValue, value, floatValue } = values;
                        // do something with floatValue
                        // onChange({ bundlePrice: value.replace(/^0+/, '') })
                        let v = value.replace(/[^0-9]/g, "")
                        if (!v) {
                          onChange({ amount: v })
                          return
                        }
                        console.log('here check number', Number(v) > 100, floatValue > 100)
                        if (form.promoCodeType && form.promoCodeType.value == "percentage") {
                          if (floatValue > 100) { v = 100 }
                        }
                        if (Number(v) <= 0) { v = "" }
                        console.log('here check number', v, form.amount)
                        onChange({ amount: v })
                      }}
                      // disabled={form._id}
                      decimalScale={0}
                      allowLeadingZeros={false}
                      allowedDecimalSeparators={false}
                      allowNegative={false}
                      thousandSeparator
                      customInput={TCInput} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item container xs={12} md={12} sx={{ p: 1, pl: 0, pr: 0 }}>
                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                  <TCSelect
                    label={"Type"}
                    value={form.orderType}
                    onChange={(e) => {
                      if (e.value != "booking" || e.value != "add_on") {
                        onChange({
                          orderType: e,
                          hours: [],
                          hourStart: null,
                          hourEnd: null
                        })
                      }
                      onChange({
                        orderType: e
                      })
                    }}
                    options={orderTypeCategoryOptions}
                  />
                </Grid>
                <Grid container item xs={12} md={8}>
                  {
                    form.orderType.value == "booking" &&
                    <Grid xs={12} md={12} sx={{ p: 1 }}>
                      <TCSelect
                        label={"Category"}
                        isMulti={true}
                        value={form.sportCourtTypeId}
                        onChange={(e) => {
                          onChange({
                            sportCourtTypeId: e
                          })
                        }}
                        options={bookingCategory}
                      />
                    </Grid>
                  }
                  {
                    form.orderType.value == "add_on" &&
                    <Grid xs={12} md={12} sx={{ p: 1 }}>
                      <TCSelect
                        label={"Add On Category"}
                        isMulti={true}
                        value={form.addOnCategoryId}
                        onChange={(e) => {
                          onChange({
                            addOnCategoryId: e
                          })
                        }}
                        options={addOnCategory}
                      />
                    </Grid>
                  }
                </Grid>
                <Grid item xs={12} md={4} sx={{ p: 1 }}>
                  <TCSelect
                    label={"Requirement"}
                    isClearable={true}
                    value={form.minimumType}
                    onChange={(e) => {
                      if (!e) {
                        onChange({
                          minimumType: e,
                          minimumPurchase: null,
                          minimumSessions: null
                        })
                        return
                      }
                      onChange({
                        minimumType: e
                      })
                    }}
                    options={(form.orderType.value == 'booking' || form.orderType.value == 'add_on') ? minimumTypeOptions : [{ value: "purchase", label: "Total Amount" },]}
                  />
                </Grid>
                {
                  (form.minimumType && form.minimumType.value == "purchase") &&
                  <Grid item xs={12} md={4} sx={{ p: 1 }}>
                    {/* <TCInput value={form.minimumPurchase} onChange={(e) => {
                          let value = e.currentTarget.value.replace(/[^0-9]/g, "")
                          if (!value) {
                              onChange({minimumPurchase: value})
                              return
                          }
                          if (Number(value) <= 0) { value = "" }
                            onChange({minimumPurchase: value})
                          }} label={"Minimum"}/> */}
                    <Grid item>
                      <Grid item container spacing={1}>
                        <Grid item>
                          <TCLabel style={{
                            color: 'rgb(133, 133, 133)'
                          }}>Minimum</TCLabel>
                        </Grid>
                        <Grid item>
                          <TCLabel style={{ color: 'red' }}>{joiForm.minimumPurchase}</TCLabel>
                        </Grid>
                      </Grid>
                      <ControlledNumericFormat
                        value={form.minimumPurchase}
                        onValueChange={(values) => {
                          const { formattedValue, value, floatValue } = values;
                          // do something with floatValue
                          // onChange({ bundlePrice: value.replace(/^0+/, '') })
                          let v = value.replace(/[^0-9]/g, "")
                          if (!v) {
                            onChange({ minimumPurchase: v })
                            return
                          }
                          if (Number(v) <= 0) { v = "" }
                          onChange({ minimumPurchase: v })
                        }}
                        // disabled={form._id}
                        decimalScale={0}
                        allowLeadingZeros={false}
                        allowedDecimalSeparators={false}
                        allowNegative={false}
                        thousandSeparator
                        customInput={TCInput} />
                    </Grid>
                  </Grid>
                }
                {
                  (form.minimumType && form.minimumType.value == "session") &&
                  <Grid item xs={12} md={4} sx={{ p: 1 }}>
                    <TCInput value={form.minimumSessions} onChange={(e) => {
                      let value = e.currentTarget.value.replace(/[^0-9]/g, "")
                      if (!value) {
                        onChange({ minimumSessions: value })
                        return
                      }
                      if (Number(value) <= 0) { value = "" }
                      onChange({ minimumSessions: value })
                    }} label={<TCLabel>Minimum<span style={{ color: '#f44336' }}>{joiForm.minimumSessions}</span></TCLabel>} />
                  </Grid>
                }
              </Grid>
              <Grid container item xs={12} md={12}>
                <Grid xs={12} md={3.5} sx={{ p: 1 }}>
                  <TCInput showAlert={joiForm.startDate} type={"date"} value={form.startDate} onChange={(e) => onChange({ startDate: e.currentTarget.value })}
                    label={"Start Date"}
                    inputProps={
                      {
                        inputProps: {
                          min: moment().format('YYYY-MM-DD'),
                          // onBlur: () => {
                          //   if (form.startDate) { if(moment(form.startDate).endOf('day').toDate() < new Date()) { onChange({startDate: moment(new Date()).format('yyyy-MM-DD')}) }}
                          // }
                        }
                      }
                    } />
                </Grid>
                <Grid xs={12} md={3.5} sx={{ p: 1 }}>
                  <TCInput showAlert={joiForm.endDate} type={"date"} value={form.endDate} onChange={(e) => onChange({ endDate: e.currentTarget.value })}
                    label={"Expiry Date"}
                    inputProps={
                      { inputProps: { min: moment().format('YYYY-MM-DD') } }
                    } />
                </Grid>
                {
                  (form.orderType.value == 'booking' || form.orderType.value == 'add_on') &&
                  <Grid sx={{
                    mt: 1,
                    ml: 1
                  }} xs={12} md={4}>
                    <TCLabel style={{ color: 'rgb(133, 133, 133)' }}>Session Hours</TCLabel>
                    <div style={{ display: 'flex', width: '100%' }}>
                      <Grid sx={{
                        minWidth: 100,
                        mr: 1
                      }}>
                        <Select isDisabled={false} value={{ value: form.hourStart, label: form.hourStart }} onChange={(e) => {
                          let endTimeList = []
                          let allowPush = false
                          for (let i = 0; i < timeOptions.length; i++) {
                            if (allowPush) { endTimeList.push(timeOptions[i]) }
                            if (e.value == timeOptions[i].value) { allowPush = true }
                          }
                          setEndTimeOptions(endTimeList)
                          onChange({ hourStart: e.value })
                        }} options={timeOptions} />
                      </Grid>
                      <Grid sx={{
                        minWidth: 100
                      }}>
                        <Select isDisabled={false} value={{ value: form.hourEnd, label: form.hourEnd }} onChange={(e) => {
                          onChange({ hourEnd: e.value })
                        }} options={endTimeOptions} />
                      </Grid>
                    </div>
                  </Grid>
                }
              </Grid>
              <Grid container item xs={12} md={12}>
                <Grid xs={6} md={4} sx={{ p: 1 }}>
                  <TCInput value={form.limit} onChange={(e) => {
                    let value = e.currentTarget.value.replace(/[^0-9]/g, "")
                    if (!value) {
                      onChange({ limit: value })
                      return
                    }
                    if (Number(value) <= 0) { value = "" }
                    onChange({ limit: value })
                  }} label={"Limit Global"} showAlert={joiForm.limit}/>
                </Grid>
                <Grid xs={6} md={4} sx={{ p: 1 }}>
                  <TCInput value={form.limitUser} onChange={(e) => {
                    let value = e.currentTarget.value.replace(/[^0-9]/g, "")
                    if (!value) {
                      onChange({ limitUser: value })
                      return
                    }
                    if (Number(value) <= 0) { value = "" }
                    onChange({ limitUser: value })
                  }} label={"Limit User / Month"} showAlert={joiForm.limitUser}/>
                </Grid>
                <Grid xs={6} md={4} sx={{ p: 1 }}>
                  <TCInput value={form.limitUserDaily} onChange={(e) => {
                    let value = e.currentTarget.value.replace(/[^0-9]/g, "")
                    if (!value) {
                      onChange({ limitUserDaily: value })
                      return
                    }
                    if (Number(value) <= 0) { value = "" }
                    onChange({ limitUserDaily: value })
                  }} label={"Limit User / Daily"} />
                </Grid>
              </Grid>
              {
                !isMerchant() &&
                <Grid item xs={12} md={12} sx={{ p: 1 }}>
                  <TCLabel style={{ color: 'rgb(133, 133, 133)' }}>User</TCLabel>
                  <AsyncSelect
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 }),
                      ...TCSelectStyle,
                    }}
                    placeholder={'Select User...'}
                    isClearable
                    async
                    defaultOptions
                    loadOptions={loadUserOption}
                    isMulti={true}
                    value={form.user} onChange={(e) => { onChange({ user: e }) }}
                  />
                </Grid>
              }
              {
                !isMerchant() &&
                <Grid sx={{ p: 1 }} xs={12} md={12}>
                  <TCLabel style={{ color: 'rgb(133, 133, 133)' }}>Issuer</TCLabel>
                  <AsyncSelect
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 }),
                      ...TCSelectStyle,
                    }}
                    placeholder={'Select User...'}
                    isClearable
                    async
                    defaultOptions
                    loadOptions={loadIssuerOption}
                    isMulti={true}
                    value={form.issuer} onChange={(e) => {
                      console.log(e)
                      onChange({
                        issuer: e
                      })
                    }} />
                </Grid>
              }
              {/* <Grid item xs={12} md={12} sx={{p: 1}}>
                    <FormControlLabel control={<Switch checked={form.isActive} onChange={() => {
                        onChange({isActive: !form.isActive})
                    }} />} label={<TCLabel>Active</TCLabel>} />
                </Grid> */}
              <Grid item xs={12} md={12} sx={{ p: 1 }}>
                <FormControlLabel control={<Checkbox checked={form.autoPopup}
                  disabled={disablePopup && (disablePopup._id !== form._id)}
                  onChange={() => {
                    onChange({ autoPopup: !form.autoPopup })
                  }} />} label={<TCLabel>Auto Pop Up</TCLabel>} />
                {
                  (disablePopup && (disablePopup._id !== form._id)) &&
                  <TCLabel subtitle style={{
                    color: 'rgba(0, 0, 0, 0.38)'
                  }}>
                    AUTO POP UP IS ALREADY SET FOR : <span style={{
                      color: '#2196f3',
                      cursor: 'pointer',
                      textDecoration: 'underline'
                    }}
                      onClick={() => {
                        // navigate()
                        window.open(`/${getUrlCourtCode()}/coupons/edit/${disablePopup._id}`, '_blank')
                        // window.location.href = `/coupons/edit/${disablePopup._id}`
                      }}
                    >{disablePopup.name}</span></TCLabel>
                }
              </Grid>
            </Grid>
            {/* <Grid container direction={"row"} sx={{
                p: 2
            }}>
            </Grid> */}
            <Grid container direction={"row"} sx={{
              pl: 3, pb: 3
            }
            }>
              <Button variant="contained" disabled={checkDisabled()} onClick={() => {
                saveCodePromo()
              }}>{form._id ? "Update" : "Add"}</Button>
            </Grid>
          </Box>
        </Card>
      </Grid >
    </>
  )
}

function MapOptions({
  options = [], value
}) {
  let option = null
  for (let i = 0; i < options.length; i++) {
    if (options[i].value == value) {
      option = options[i]
      break;
    }
  }
  return option
}

function convertHourstoArray({
  startHours, endHours
}) {
  let hours = []

  if (!startHours || !endHours) {
    return hours
  }

  let startH = Number(startHours.split(":")[0])
  let endH = Number(endHours.split(":")[0])
  for (let i = startH; i < endH; i++) {
    hours.push(`${i < 10 ? 0 : ''}${i}:00`)
  }
  return hours
}

export default AddCoupon;
